import { useEffect } from 'react';

import { FormPageLayout } from '@/components/layout/form-page-layout';
import { usePageHeader } from '@/contexts/PageHeaderContext';
import { useGo } from '@/hooks/useResourceNavigation';
import { useRouteParams } from '@/contexts/RouteContext';

export const CustomersView = () => {
        const { setPageHeader, resetPageHeader } = usePageHeader();
        const go = useGo();
        const { id } = useRouteParams();

        useEffect(() => {
                setPageHeader({
                        title: 'Customer Details',
                        description: `View customer information`,
                        showBackButton: true,
                        onBackClick: () => go({ to: '/customers' })
                });

                return () => {
                        resetPageHeader();
                };
        }, [setPageHeader, resetPageHeader, go]);

        return (
                <FormPageLayout>
                        <div className="flex items-center justify-center min-h-[400px]">
                                <div className="text-center">
                                        <h3 className="text-lg font-semibold">Customer Details</h3>
                                        <p className="text-muted-foreground mt-2">
                                                Customer details view will be implemented here.
                                                <br />
                                                Customer ID: {id}
                                        </p>
                                </div>
                        </div>
                </FormPageLayout>
        );
};
